import type { ControlValue } from "../../state/controlStore";
import type { ParameterPath } from "../../state/parameterRoutes";
import type { EngineSnapshot, UserControls } from "../../state/types";
import { Slider } from "../ui/Slider";

export interface MainControlsProps {
  controls: UserControls;
  snapshot: EngineSnapshot;
  setControl: (path: ParameterPath, value: ControlValue) => void;
}

/** Controls that exist in the spec but have nothing to act on until later phases. */
const PENDING_CONTROLS = [
  { label: "Response", phase: "Phase 2" },
  { label: "Initiative", phase: "Phase 2" },
  { label: "Tension", phase: "Phase 1B" },
];

export function MainControls({ controls, snapshot, setControl }: MainControlsProps) {
  const d = snapshot.diagnostics;

  return (
    <section className="panel panel--static" aria-labelledby="main-controls-title">
      <div className="panel__header">
        <h2 id="main-controls-title" className="transport__title">
          Main Controls
        </h2>
        <span className="panel__badge">
          E {d.currentEnergy.toFixed(2)} / D {d.currentDensity.toFixed(2)}
        </span>
      </div>

      <div className="panel__body panel__body--open">
        <Slider
          label="Energy"
          value={controls.main.energy}
          min={0}
          max={1}
          step={0.01}
          displayValue={`${controls.main.energy.toFixed(2)} → ${d.currentEnergy.toFixed(2)}`}
          hint="音の強さ。velocity、アクセントの深さ、キックの強度、フィルの出やすさへ効きます。音数は変えません。"
          onChange={(value) => {
            setControl("main.energy", value);
          }}
        />
        <Slider
          label="Density"
          value={controls.main.density}
          min={0}
          max={1}
          step={0.01}
          displayValue={`${controls.main.density.toFixed(2)} → ${d.currentDensity.toFixed(2)}`}
          hint="音数。1小節あたりのイベント数と、鳴る役割の数へ効きます。音の強さは変えません。"
          onChange={(value) => {
            setControl("main.density", value);
          }}
        />

        <p className="transport__hint">
          表示は「スライダー値 → 平滑後の現在値」です。EnergyとDensityは独立して作用します。
        </p>

        <ul className="pending-controls">
          {PENDING_CONTROLS.map((item) => (
            <li key={item.label}>
              <span>{item.label}</span>
              <span className="pending-controls__phase">{item.phase}で有効化</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
